import { connect } from 'react-redux';
import { get } from 'lodash';

import PublicEventThermometer from './PublicEventThermometer';

const mapStateToProps = state => ({
    platform: get(state, 'platform.platform'),
    campaign: get(state, 'campaign.campaign'),
    locale: get(state, 'session.language'),
    isBillingConfigured: get(state, 'organization.isBillingConfigured'),
});

export default connect(mapStateToProps)(PublicEventThermometer);
